export const TXTCLI_Column_Settings = {
  "id": "TXTCLI_Column_Settings",
  "defaultMessage": "Column Settings"
} as const;

export const TXTCLI_Favorite = {
  "id": "TXTCLI_Favorite",
  "defaultMessage": "Favorite"
} as const;

export const TXTCLI_Game = {
  "id": "TXTCLI_Game",
  "defaultMessage": "Game"
} as const;

export const TXTCLI_Stakes = {
  "id": "TXTCLI_Stakes",
  "defaultMessage": "Stakes"
} as const;

export const TXTCLI_Type = {
  "id": "TXTCLI_Type",
  "defaultMessage": "Type"
} as const;

export const TXTCLI_Buy_In = {
  "id": "TXTCLI_Buy_In",
  "defaultMessage": "Buy-In"
} as const;

export const TXTCLI_Players = {
  "id": "TXTCLI_Players",
  "defaultMessage": "Players"
} as const;

export const TXTCLI_Column_Customization = {
  "id": "TXTCLI_Column_Customization",
  "defaultMessage": "Column Customization"
} as const;

export const TXTCLI_Month = {
  "id": "TXTCLI_Month",
  "defaultMessage": "Month"
} as const;

export const TXTCLI_Year = {
  "id": "TXTCLI_Year",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "Year"
} as const;

export const TXTCLI_LoadingXX = {
  "id": "TXTCLI_LoadingXX",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "Loading..."
} as const;

export const TXTCLI_Close = {
  "id": "TXTCLI_Close",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "Close"
} as const;

export const TXTCLI_Table_Size = {
  "id": "TXTCLI_Table_Size",
  "defaultMessage": "Table Size"
} as const;

export const TXTCLI_2_seat_table_XHeads_upX = {
  "id": "TXTCLI_2_seat_table_XHeads_upX",
  "defaultMessage": "2 seat table (Heads-up)"
} as const;

export const TXTCLI_N0_seat_table = {
  "id": "TXTCLI_N0_seat_table",
  "defaultMessage": "{0} seat table"
} as const;

export const TXTCLI_Game_Speed = {
  "id": "TXTCLI_Game_Speed",
  "defaultMessage": "Game Speed"
} as const;

export const TXTCLI_Team_PokerStars_player = {
  "id": "TXTCLI_Team_PokerStars_player",
  "defaultMessage": "Team PokerStars player"
} as const;

export const TXTCLI_Hyper_Turbo = {
  "id": "TXTCLI_Hyper_Turbo",
  "defaultMessage": "Hyper-Turbo"
} as const;

export const TXTCLI_Regular = {
  "id": "TXTCLI_Regular",
  "defaultMessage": "Regular"
} as const;

export const TXTCLI_Slow = {
  "id": "TXTCLI_Slow",
  "defaultMessage": "Slow"
} as const;

export const TXTCLI_Turbo = {
  "id": "TXTCLI_Turbo",
  "defaultMessage": "Turbo"
} as const;

export const TXTCLI_Currencies = {
  "id": "TXTCLI_Currencies",
  "defaultMessage": "Currencies"
} as const;

export const TXTCLI_CurrTitle_USD = {
  "id": "TXTCLI_CurrTitle_USD",
  "defaultMessage": "US Dollars"
} as const;

export const TXTCLI_CurrTitle_GBP = {
  "id": "TXTCLI_CurrTitle_GBP",
  "defaultMessage": "British Pounds"
} as const;

export const TXTCLI_CurrTitle_EUR = {
  "id": "TXTCLI_CurrTitle_EUR",
  "defaultMessage": "Euro"
} as const;

export const TXTCLI_CurrTitle_CAD = {
  "id": "TXTCLI_CurrTitle_CAD",
  "defaultMessage": "Canadian Dollars"
} as const;

export const TXTCLI_Game_types = {
  "id": "TXTCLI_Game_types",
  "defaultMessage": "Game types"
} as const;

export const TXTCLI_Progressive_Knockout = {
  "id": "TXTCLI_Progressive_Knockout",
  "defaultMessage": "Progressive Knockout"
} as const;

export const TXTCLI_Zoom = {
  "id": "TXTCLI_Zoom",
  "defaultMessage": "Zoom"
} as const;

export const TXTCLI_Total_Progressive_Knockout = {
  "id": "TXTCLI_Total_Progressive_Knockout",
  "defaultMessage": "Total Progressive Knockout"
} as const;

export const TXTCLI_HoldXem = {
  "id": "TXTCLI_HoldXem",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "Hold'em"
} as const;

export const TXTCLI_Mystery_Bounty_Tournament = {
  "id": "TXTCLI_Mystery_Bounty_Tournament",
  "defaultMessage": "Mystery Bounty Tournament"
} as const;

export const TXTCLI_Team_PokerStars_Bounty = {
  "id": "TXTCLI_Team_PokerStars_Bounty",
  "defaultMessage": "Team Pro Bounty"
} as const;

export const TXTCLI_Join_Waiting_List = {
  "id": "TXTCLI_Join_Waiting_List",
  "defaultMessage": "Join Waiting List"
} as const;

export const TXTCLI_Observe = {
  "id": "TXTCLI_Observe",
  "defaultMessage": "Observe"
} as const;

export const TXTCLI_Play_Now = {
  "id": "TXTCLI_Play_Now",
  "defaultMessage": "Play Now"
} as const;

export const TXTCLI_Play_at_a_Similar_Table = {
  "id": "TXTCLI_Play_at_a_Similar_Table",
  "defaultMessage": "Play at a Similar Table"
} as const;

export const TXTCLI_Cash_Game_Rules = {
  "id": "TXTCLI_Cash_Game_Rules",
  "defaultMessage": "Cash Game Rules"
} as const;

export const TXTCLI_Buy_in_Range = {
  "id": "TXTCLI_Buy_in_Range",
  "defaultMessage": "Buy-in Range"
} as const;

export const TXTCLI_Take_seat = {
  "id": "TXTCLI_Take_seat",
  "defaultMessage": "Take seat"
} as const;

export const TXTCLI_Waiting = {
  "id": "TXTCLI_Waiting",
  "defaultMessage": "Waiting"
} as const;

export const TXTCLI_Dealer = {
  "id": "TXTCLI_Dealer",
  "defaultMessage": "Dealer"
} as const;

export const TXTCLI_Table = {
  "id": "TXTCLI_Table",
  "defaultMessage": "Table"
} as const;

export const TXTCLI_Favorite_Tables = {
  "id": "TXTCLI_Favorite_Tables",
  "defaultMessage": "Favorite Tables"
} as const;

export const TXTCLI_Information = {
  "id": "TXTCLI_Information",
  "defaultMessage": "Information"
} as const;